/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface SetPasLastViewed200Response
 */
export interface SetPasLastViewed200Response {
    /**
     * 
     * @type {string}
     * @memberof SetPasLastViewed200Response
     */
    message?: string;
}


/**
 * Check if a given object implements the SetPasLastViewed200Response interface.
 */
export function instanceOfSetPasLastViewed200Response(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function SetPasLastViewed200ResponseFromJSON(json: any): SetPasLastViewed200Response {
    return SetPasLastViewed200ResponseFromJSONTyped(json, false);
}

export function SetPasLastViewed200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetPasLastViewed200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function SetPasLastViewed200ResponseToJSON(value?: SetPasLastViewed200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'message': value.message,
    };
}

